import { Component, OnInit } from '@angular/core'

import { LanguageService } from '../../../services/language/language.service';
import { HttpService } from '../../../services/http/http.service';
import { UtilsService } from '../../../services/utils/utils.service';

import { WaitingSpinnerComponent } from '../../utils/waiting-spinner/waiting-spinner.component';

// Environment varialbes
import { environment } from '../../../../environments/environment';


import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatButtonModule } from '@angular/material/button';


// Form control
import {ReactiveFormsModule, UntypedFormControl, FormGroupDirective, NgForm, Validators, UntypedFormBuilder} from '@angular/forms';
import {ErrorStateMatcher} from '@angular/material/core';

// Error when invalid control is dirty, touched, or submitted (input fields) 
export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: UntypedFormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form?.submitted;
    return !!(control?.invalid && (control.dirty || control.touched || isSubmitted));
  }
}


@Component({
  selector: 'app-contact',
  standalone: true,
  imports: [
    // Angular modules
    CommonModule,
    MatFormFieldModule,
    MatInputModule,
    MatCheckboxModule,
    ReactiveFormsModule,
    MatButtonModule,
    // Custom modules
    WaitingSpinnerComponent,
  ],
  templateUrl: './contact.component.html',
  styleUrl: './contact.component.css',
})
export class ContactComponent implements OnInit {


  // Waiting popup info
  displayWaitingSpiner = false
  waitingMessage = ''


  // Form information 
  formControlGroup_Contact = this.formBuilder.group({    
    fullName: new UntypedFormControl('', [Validators.required]),
    company: new UntypedFormControl('', []), 
    phone: new UntypedFormControl('', []),
    email: new UntypedFormControl('', [Validators.required, Validators.email]),
    geographicalArea: new UntypedFormControl('', []),
    message: new UntypedFormControl('', [Validators.required]),
    checkBox_privacyPolicy: new UntypedFormControl(null, [Validators.required]),
    checkBox_publicity: new UntypedFormControl(null, []),
  })
  matcher = new MyErrorStateMatcher();
  maximumMessageLength_SingleLine:number = 100
  maximumMessageLength_MultiLine:number = 500


  currentLanguageCode:string = ''



  /* 
  Se ha marcado "formBuilder" como "readonly", porque el formulario "formControlGroup_Contact" 
  se crea al inicio y no se vuelve modificar después. Esto es una buena práctica, ya que evita 
  modificaciones accidentales y garantiza que la estructura del formulario permanezca inmutable.
    
  Lo mismo ocurre con los servicios "httpService" y "utilsService", estos se inyectan en el 
  constructor y no se vuelven a modificar.
  */
  constructor(
    public languageService:LanguageService,
    private readonly formBuilder: UntypedFormBuilder,
    private readonly httpService: HttpService,
    private readonly utilsService: UtilsService
  ) { }

  ngOnInit(): void {
    // Scroll to the top every time the page is loaded
    window.scrollTo(0,0)
  }


  handleChangeCheckBox_PrivacyPolicy(event:any){
    if(!event.checked){
      this.formControlGroup_Contact.controls['checkBox_privacyPolicy'].setValue(null);
    }
  }

  handleChangeCheckBox_Publicity(event:any){
    if(!event.checked){
      this.formControlGroup_Contact.controls['checkBox_publicity'].setValue(null);
    }
  }



  async submit(){
    // Get strings
    let fullName = this.formControlGroup_Contact.controls['fullName'].value
    let company = this.formControlGroup_Contact.controls['company'].value
    let phone = this.formControlGroup_Contact.controls['phone'].value
    let email = this.formControlGroup_Contact.controls['email'].value
    let geographicalArea = this.formControlGroup_Contact.controls['geographicalArea'].value
    let message = this.formControlGroup_Contact.controls['message'].value
    let subscribeToPublicity = false
    if(this.formControlGroup_Contact.controls['checkBox_publicity'].value){
      subscribeToPublicity = true;
    }
    //let languageCode = this.languageService.languageCode
    let languageCode = this.currentLanguageCode

    let urlString:string = environment.googleCloudRun.newContactSubmission

    let formData = new FormData();
    formData.append('fullName', fullName)
    formData.append('company', company)
    formData.append('phone', phone)
    formData.append('email', email)
    formData.append('geographicalArea', geographicalArea)
    formData.append('message', message)
    formData.append('subscribeToPublicity', JSON.stringify(subscribeToPublicity))
    formData.append('languageCode', languageCode)

    // Display waiting popup
    this.waitingMessage = this.languageService.Strings.contactPageStrings.waitingMessage_submittingForm
    this.displayWaitingSpiner = true
    const resultDict = await this.httpService.executeHttpPostMethod(urlString, formData)
    // Stop displaying the waiting popup
    this.displayWaitingSpiner = false

    // Manage the result
    if(resultDict['resultOk']){
      // Success
      this.utilsService.displayInformationPopup(
        this.languageService.Strings.contactPageStrings.success_title,
        this.languageService.Strings.contactPageStrings.success_message
      )
    }else{
      // Failed
      this.utilsService.displayInformationPopup(
        this.languageService.Strings.contactPageStrings.error_title,
        this.languageService.Strings.contactPageStrings.error_message
      )
    }
  }




  // ----- Language service subscription ----- //
  subscribeToLanguageService(){
    this.languageService.getCurrentLanguageCode().subscribe(async (currentLanguageCode:string) => {
      this.currentLanguageCode = currentLanguageCode
    });
  }

}
